import tools from '@/utils/tools';

//获取商品列表
const list = async function(params,that){
  var url = "/backend/Goods/list.html"
  const res = await tools.post(url,params,that);
  return res
}
//保存商品列表
const saveGoods = async function(params,that){
  var url = "/backend/Goods/saveGoods.html"
  const res = await tools.post(url,params,that);
  return res
}
//修改商品排序
const changeSort = async function(params,that){
  var url = "/backend/Goods/changeSort.html"
  const res = await tools.post(url,params,that);
  return res
}
//获取商品接口
const getGoods = async function(params,that){
  var url = "/backend/Goods/get.html";
  const res = await tools.post(url,params,that);
  return res
}
//删除商品接口
const delGoods = async function(params,that){
  var url = "/backend/Goods/del.html";
  const res = await tools.post(url,params,that);
  return res
}
//审核商品接口
const examineAll = async function(params,that){
  var url = "/backend/Goods/examineAll.html";
  const res = await tools.post(url,params,that);
  return res
}
//获取商品目录
const Cataloglist = async function(params,that){
  var url = "/backend/Goods/Cataloglist.html"
  const res = await tools.post(url,params,that);
  return res
}
//保存商品列表
const saveGoodsCatalog = async function(params,that){
  var url = "/backend/Goods/saveGoodsCatalog.html"
  const res = await tools.post(url,params,that);
  return res
}
//获取商品目录
const getGoodsCatalog = async function(params,that){
  var url = "/backend/Goods/getGoodsCatalog.html";
  const res = await tools.post(url,params,that);
  return res
}
//删除商品接口
const delGoodsCatalog = async function(params,that){
  var url = "/backend/Goods/delGoodsCatalog.html";
  const res = await tools.post(url,params,that);
  return res
}
//审核商品接口
const examineAllGoodsCatalog = async function(params,that){
  var url = "/backend/Goods/examineAllGoodsCatalog.html";
  const res = await tools.post(url,params,that);
  return res
}

//审核商品接口
const importCatalog = async function(params,that){
  var url = "/backend/Goods/importCatalog.html";
  const res = await tools.post(url,params,that);
  return res
}

//审核商品接口
const exportCatalog = async function(params,that){
  var url = "/backend/Goods/exportCatalog.html";
  const res = await tools.post(url,params,that);
  return res
}

//审核商品接口
const importGood = async function(params,that){
  var url = "/backend/Goods/importGood.html";
  const res = await tools.post(url,params,that);
  return res
}

//审核商品接口
const exportGood = async function(params,that){
  var url = "/backend/Goods/exportGood.html";
  const res = await tools.post(url,params,that);
  return res
}

const goodsFunction = {
  list,
  saveGoods,
  changeSort,
  getGoods,
  delGoods,
  examineAll,
  Cataloglist,
  saveGoodsCatalog,
  getGoodsCatalog,
  delGoodsCatalog,
  examineAllGoodsCatalog,
  importCatalog,
  exportCatalog,
  importGood,
  exportGood,
}

export default goodsFunction;


// WEBPACK FOOTER //
// ./src/api/goods.js